import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';

import { select } from '@angular-redux/store';

import { Observable ,  Subscription } from 'rxjs';

import * as Store from '@core/redux/stores';

import { environment } from '@environments/environment';
import { ModalService, AlertService } from '@core/services';
import * as _ from 'lodash-es';

 import { MealOptionService } from '@features/customization/services/mealoption.service';  // '@core/ /services/mealoption.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-choose-your-meal',
  templateUrl: './choose-your-meal.component.html',
  styleUrls: ['./choose-your-meal.component.less'],
  providers: [AlertService]
})
export class ChooseYourMealComponent implements OnInit, OnDestroy {
  @select((appState) => appState.locationSelected) locationSelected: Observable<Store.LocationsEntity>;

  public activeMenuMealOptions: Store.ParentRecipeEntity;
  public menuImageUrlPrefix: string = environment.IMG_ENDPOINT + '/food';

  private subscriptions = new Subscription();
  loading = false;

  @Output() mealOptoinChangeEvent = new EventEmitter<any>();
  private isModalDismissed: boolean;

  constructor(private modalService: ModalService,
    private mealOptionService: MealOptionService,
    private alertService: AlertService,
    private location: Location  ) { }

  ngOnInit() {
    this.isModalDismissed = false;
    this.activeMenuMealOptions = JSON.parse(sessionStorage.getItem('mealOptions'));
    this.locationSelected.subscribe((Succ) => {
    }, (Err) => {
      this.alertService.error(Err.error.message);
    });
  }

  chooseMealOption(mealoption) {
    sessionStorage.setItem('isMealOptionChanged', 'true');
    this.mealOptionService.updateActiveRecipeID(mealoption.id);
    this.modalService.hideModal();
  }

  getMealOptionName(title: string, sub: string) {
    let mealName = this.getRecipeSubTitle(title, sub);
    mealName = mealName ? mealName : title + ' Only';
    return mealName;
  }

  getRecipeSubTitle(title: string, sub: string) {
    const value = sub ? (sub.replace(title, '')).trim() : '';
    const subVal = value ? value.replace(/^,/g, '').trim() : '';
    return subVal;
  }
  hide() {
    this.isModalDismissed = true;
    const childRecipeId = sessionStorage.getItem('childRecipeId');
    this.modalService.hideModal();
    if(!childRecipeId) {      
      this.location.back();
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    const childRecipeId = this.mealOptionService.activeRecipeID;
    if(!childRecipeId && !this.isModalDismissed) {      
      this.location.back();
    }
  }
  isCurrentMealOptionSelected(mealOption: Store.ChildRecipeEntity) {
    const childRecipeId = sessionStorage.getItem('childRecipeId') ?? '';
    return childRecipeId === mealOption?.id?.toString();
  }
}
